"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _semanticUiReact = require("semantic-ui-react");

var Dropdown = function (_D) {
  (0, _inherits2.default)(Dropdown, _D);

  function Dropdown() {
    (0, _classCallCheck2.default)(this, Dropdown);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Dropdown).apply(this, arguments));
  }

  (0, _createClass2.default)(Dropdown, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextProps !== this.props || nextState !== this.state;
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(Dropdown.prototype), "componentWillReceiveProps", this).call(this, nextProps);

      if (nextProps.value !== this.props.value) {
        this.setValue(nextProps.value);
        this.setSelectedIndex(nextProps.value);
      }

      if (nextProps.options !== this.props.options) {
        this.setSelectedIndex(undefined, nextProps.options);
      }
    }
  }]);
  return Dropdown;
}(_semanticUiReact.Dropdown);

exports.default = Dropdown;